import { FC } from "react";
import { useTranslation } from "react-i18next";

import Chart1 from "../../../../assets/images/content/pillar-1/material-recovered-from-waste/materials-recovered-chart-1-mobile.webp";
import Chart2 from "../../../../assets/images/content/pillar-1/material-recovered-from-waste/materials-recovered-chart-2-mobile.webp";

const MaterialsRecoveredFromWaste: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-8">
			<div className="grid w-full 2xl:w-3/4 self-left grid-cols-1 sm:grid-cols-2 gap-10 md:gap-6 2xl:gap-10">
				<div className="flex flex-col gap-4">
					<div className="grow">
						<p className="h4">{t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.industryFlows.title")}</p>
					</div>
					<img
						className="self-start"
						src={Chart1}
						alt={t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.industryFlows.alt") as string}
						title={t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.industryFlows.alt") as string}
					/>
				</div>
				<div className="flex flex-col gap-4">
					<div className="grow">
						<p className="h4">{t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.complementaryFlows.title")}</p>
					</div>
					<img
						className="self-start"
						src={Chart2}
						alt={t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.complementaryFlows.alt") as string}
						title={t("pages.pillar.pillar1.materialsRecoveredFromWaste.blocks.visual.complementaryFlows.alt") as string}
					/>
				</div>
			</div>
		</div>
	);
};

export { MaterialsRecoveredFromWaste };
